// XPEN-3467: one sizing rule for every autocomplete/select dropdown in the app.
//
// Both dropdown libraries pin their option list to the width of the control it
// hangs from, and both do it inline so no stylesheet rule can override it:
//
//   * MUI Autocomplete renders the popper with `style={{ width: anchorEl.clientWidth }}`.
//   * react-select defaults its `menu` to `width: 100%` of the control.
//
// In a narrow table column that forces long options to wrap over several lines.
// Treat the control's width as a floor instead: size to the content, never go
// below the control, and cap so the list can't run off a narrow viewport.

// Widest a dropdown may get. The vw term keeps it on screen on a phone; the rem
// term stops a single very long option from stretching the list across a wide
// desktop. Past this the option wraps, which is why every dropdown's options
// keep their wrapping style.
export const DROPDOWN_MAX_WIDTH = 'min(90vw, 34rem)';

/**
 * Sizing for a dropdown's option list.
 *
 * @param {string|number} anchorWidth The control's width, as the floor. MUI
 *   gives a computed pixel value on the popper's `style`; react-select's menu
 *   is positioned against the control (or, when portalled, against a wrapper
 *   already set to the control's width), so `'100%'` resolves correctly there.
 */
export const dropdownWidthStyle = (anchorWidth) => ({
    width: 'max-content',
    minWidth: anchorWidth,
    maxWidth: DROPDOWN_MAX_WIDTH,
});
